import { createContext } from "react"
const GlobalAppContext = createContext({})
export { GlobalAppContext }